
export default {
    props: {
        value : Number,
        title: String
    },
    computed: {
        scorePercentage() {
            return this.value*20;
        },
    }
}
